var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.template.img)?_c('img',{staticClass:"content",attrs:{"src":_vm.src}}):(_vm.template.video)?_c('img',{staticClass:"content",attrs:{"src":_vm.src}}):_c('img',{style:({ 'max-width': '100%' }),attrs:{"src":require("assets/images/nft-mock.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }